<template>
  <div class="">
    <a v-if="showFormActions.assigneAccess" :href="taskFormResponseUrl" class="btn btn-sm btn-success float-right" target="_blank">Save Your Response</a>
    <a v-if="showFormActions.ownerAccess" :href="lockFormResponseUrl" class="btn btn-sm btn-dark float-right" target="_blank">Lock Response</a>
    <button
      type="button"
      class="btn btn-sm btn-primary float-right mr-2"
      @click.prevent="ViewSignatureModal"
      >View Signatures</button>

    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('form_responses')"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>

    </div>

    <app-table
      :id="tableId"
      :options="options"
      :card-view="true"
      @action="getListAction"
    />
    <form-endorse-modal
      :task_id="task_id"
      :form_revision_id="form_revision_id"
      v-if="isViewSignatureModalActive"
      @close-modal="closeModal"
    />
  </div>
</template>

<script>

import AppFunction from "@/core/helpers/app/AppFunction";
import {axiosPost} from "@/app/Helpers/AxiosHelper";
import {FORM_ACCEPT, FORM_REJECT, TASK_FORM_RESPONSES,} from "@/app/Config/ApiUrl";
import CoreLibrary from "@/core/helpers/CoreLibrary";
import {TableHelpers} from "@Views/Demo/Tables/mixins/TableHelpers";

export default {
  extends: CoreLibrary,
  name: "FormResponseGridView",
  mixins: [TableHelpers],
  data() {
    return {
      isViewSignatureModalActive: false,
      form_revision_id: '',
      task_id: '',
      url: '',
      saveResponse: false,
      result: this.$attrs["props"].status,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      taskFormResponseUrl:'',
      lockFormResponseUrl:'',
      request: {},
      tableId: "grid-view-table",
      rowData: {},
      options: {
        name: "AdvanceTable",
        url: TASK_FORM_RESPONSES,
        cardViewComponent: "ResponseGrid",
        // url: actions.DATATABLE_DATA,
        showHeader: true,
        columns: [
          {
            title: this.$t("user"),
            type: "media-object",
            key: "media-object",
            mediaTitleKey: "title",
            mediaSubtitleKey: "email",
            default: AppFunction.getAppUrl("images/avatar-demo.jpg"),
            modifier: (value, row) => {
              return value; // imag url
            },
            isVisible: true,
          },
          {
            title: this.$t("full_name"),
            type: "text",
            key: "full_name",
          },
          {
            title: this.$t("last_updated"),
            type: "text",
            key: "responseData",
            modifier: (value, row) => {
              return value.updated_at; // imag url
            },
          },
          // {
          //   title: this.$t("status"),
          //   type: "custom-html",
          //   key: "status",
          //   isVisible: true,
          //   modifier: (value) => {
          //     let ClassName = "danger";
          //
          //     if (value === "active") ClassName = `success`;
          //     else if (value === "invited") ClassName = `warning`;
          //
          //     return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
          //       value
          //     )}</span>`;
          //   },
          // },

        ],
        actions: [
          {
            title: this.$t("accept"),
            // icon: "eye",
            type: "none",
            // component: 'app-add-modal',
            // modalId: 'demo-add-edit-Modal',
          },
          {
            title: this.$t("reject"),
            // icon: "eye",
            type: "none",
            // component: 'app-add-modal',
            // modalId: 'demo-add-edit-Modal',
          },

        ],
        filters: [
          {
            title: this.$t("is_private"),
            type: "checkbox",
            key: "is_private",
            option: [
              { id: "0", value: "Public" },
              { id: "1", value: "Private" },
            ],
          },
        ],
        showFilter: false,
        showSearch: false,
        showCount: true,
        showClearFilter: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },
  created() {
    this.options.url = this.formResponseUrl()
    this.options.columns = [...this.options.columns, this.actionObj];
    this.$hub.$on('formRevisionIdChanged', (payload) => {
      this.getBodies();
      this.taskFormResponseUrl = this.updateTaskFormResponseUrl();
      this.lockFormResponseUrl = this.updateLockFormResponseUrl();
    })

  },
  methods: {
    ViewSignatureModal() {
      this.form_revision_id = this.$store.state.sharedData.sharedData.taskFormData.id;
      this.task_id = this.$store.state.sharedData.sharedData.taskId;
      this.isViewSignatureModalActive = true;
    },
    closeModal() {
      $("#view-signature-modal").modal("hide");
      this.isViewSignatureModalActive = false;
    },
    showResponseForm(){
      this.saveResponse = true;
    },

    getListAction(rowData, actionObj, active) {
      if (actionObj.title == this.$t("accept")) {
        // this.acceptForm(rowData.id);
      } else if (actionObj.title == this.$t("reject")) {
        // this.rejectForm(rowData.id);
      }
    },
    taskFormResponseUrlUpdate(){
      return  '/taskFormResponse/save/' + this.formBodyId + '/?form_id='+this.formId+ '&task_id='+this.taskId + '&form_revision_id='+this.formRevisionId+'&type=save_response&user_id='+this.userId;
    },
    getBodies() {
      // this.taskFormResponseUrl = this.taskFormResponseUrlUpdate();
      let id = this.$attrs['props'].id;
      this.options.url = this.formResponseUrl();

      this.$hub.$emit("reload-" + this.tableId);

    },
    acceptForm(statusId) {
      let id = this.$attrs['props'].id;
      let input = {};
      input.job_id = id;
      input.status_id = statusId;
      axiosPost(FORM_ACCEPT, input)
        .then((res) => {
          this.$toastr.s(res.data.message);
        })
        .catch((errors) => {
          
        }).finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    rejectForm(statusId) {

      let id = this.$attrs['props'].id;
      let input = {};
      input.job_id = id;
      input.status_id = statusId;
      axiosPost(FORM_REJECT, input)
        .then((res) => {
          this.$toastr.s(res.data.message);
        })
        .catch((errors) => {
          
        }).finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    searchAndSelectFilterOptions() {
      this.axiosGet(actions.CATEGORIES).then((response) => {
        let name = this.options.filters.find(
          (element) => element.title === this.$t("search_and_select_category")
        );

        name.option = response.data.map((name) => {
          return {
            id: name.id,
            value: name.value,
          };
        });
      });
    },

    formResponseUrl(){
      let status = this.$attrs.props.status;
      let id = this.$store.state.sharedData.sharedData.taskFormData.id;
      let task_id = this.$store.state.sharedData.sharedData.taskId;
      return TASK_FORM_RESPONSES + "?status="+status+ "&form_revision_id="+id +"&task_id="+task_id;
    },
    updateTaskFormResponseUrl() {
      return (
          '/taskFormResponse/save/' +
          this.$store.state.sharedData.sharedData.taskFormData.form_body_id +
          '/?form_id=' +
          this.$store.state.sharedData.sharedData.taskFormData.form_id +
          '&task_id=' +
          this.$store.state.sharedData.sharedData.taskId +
          '&form_revision_id=' +
          this.$store.state.sharedData.sharedData.taskFormData.id +
          '&type=save_response&user_id=' +
          this.userId +'&new_tab=yes'
      );
    },
    updateLockFormResponseUrl() {
      return (
          '/taskFormResponse/save/' +
          this.$store.state.sharedData.sharedData.taskFormData.form_body_id +
          '/?form_id=' +
          this.$store.state.sharedData.sharedData.taskFormData.form_id +
          '&task_id=' +
          this.$store.state.sharedData.sharedData.taskId +
          '&form_revision_id=' +
          this.$store.state.sharedData.sharedData.taskFormData.id +
          '&type=save_response&user_id=' +
          this.userId +'&new_tab=yes&lock=yes'
      );
    },
  },
  mounted() {
    this.isCardView = true;
    this.taskFormResponseUrl = this.updateTaskFormResponseUrl();
    this.lockFormResponseUrl = this.updateLockFormResponseUrl();
  },

  watch: {
    $attrs: function (newVal, oldVal) {
      this.getBodies();
      this.$hub.$emit("reload-" + this.tableId);
    },

  },

  computed:{

    userId() {
      return this.$store.state.user.loggedInUser.id;
    },
    showFormActions(){
      return this.$store.state.sharedData.sharedData?.showFormActions;
    },

  },




};
</script>
